"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledLinearProgress = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _useTheme = _interopRequireDefault(require("../useTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  width: 0%;\n  height: 8px;\n  max-width: 100%;\n  background-color: #0084ee;\n  border-radius: 4px;\n  transition-duration: 0.5s;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: rgba(0,0,0,.15);\n  border-radius: 4px;\n  width: 100%;\n  padding: 1px;\n  margin: 4px;\n  box-sizing: border-box;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledLinearProgress = _styledComponents["default"].div(_templateObject());

exports.StyledLinearProgress = StyledLinearProgress;

var StyledLinearProgressProgress = _styledComponents["default"].div(_templateObject2());

var getSafeProgress = function getSafeProgress(current, total) {
  if (current <= 0 || total <= 0) {
    return 0;
  }

  return current / total * 100;
};

var LinearProgress = function LinearProgress(_ref) {
  var color = _ref.color,
      progress = _ref.progress,
      total = _ref.total,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["color", "progress", "total", "children"]);

  var theme = (0, _useTheme["default"])();
  var barColor = theme.palette['primary']['500'];

  if (color !== 'primary' && theme.palette[color]['500']) {
    barColor = theme.palette[color]['500'];
  }

  return /*#__PURE__*/_react["default"].createElement(StyledLinearProgress, _extends({}, props, {
    barColor: barColor
  }), /*#__PURE__*/_react["default"].createElement(StyledLinearProgressProgress, {
    style: {
      width: "".concat(getSafeProgress(progress, total), "%"),
      backgroundColor: barColor
    }
  }));
};

LinearProgress.propTypes = {
  /**
   * Current progress value
   */
  progress: _propTypes["default"].number,

  /**
   * Max progress value
   */
  total: _propTypes["default"].number,

  /**
   * Type of progressbar
   */
  variant: _propTypes["default"].string,
  //PropTypes.oneOf('determinated', 'indeterminated'),

  /**
   * Color
   */
  color: _propTypes["default"].string
};
LinearProgress.defaultProps = {
  color: 'primary',
  progress: 0,
  total: 100,
  variant: 'determinated'
};
var _default = LinearProgress;
exports["default"] = _default;